import { Component, Output, EventEmitter, Input, OnChanges, SimpleChanges, inject, DestroyRef, ChangeDetectorRef, effect, ViewChild } from '@angular/core';
import { HelpersService } from 'src/app/shared/services/helpers/helpers.service';
import { EngagementService } from 'src/app/shared/services/engagement/engagement.service';
import * as moment from 'moment';
import * as _ from 'lodash';
import { Subscription } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AppStateService } from 'src/app/shared/services/helpers/app-state.service';
import { NgIf, NgClass } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { EngagementCardsComponent } from './components/engagement-cards/engagement-cards.component';
import { EngagementRecordsSummaryDrilldownComponent } from '../engagement-summary/components/engagement-records-summary-drilldown/engagement-records-summary-drilldown.component';
import { LtmsWidgetToolsComponent } from '../../ltms-widget-tools/ltms-widget-tools.component';
import { LtmsBarChartViewComponent } from '../../graph/ltms-bar-chart-view/ltms-bar-chart-view.component';
import { LtmsLoaderComponent } from '../../ltms-loader/ltms-loader.component';
import { ScoreLineChartComponent } from '../../score/score-line-chart/score-line-chart.component';
import { LtmsErrorComponent } from '../../ltms-error/ltms-error.component';
import { ScoreDropdownMenuComponent } from '../../score/score-dropdown-menu/score-dropdown-menu.component';

interface InnerTrendsObject {
  key_as_string: string;
  doc_count: number;
  number_of_request_generated_rated: number;
  number_of_unique_requests_delivered: number;
  number_of_request_generated: number;
  number_of_requests_received: number;
  ignore_this: number;
}
interface TrendsApiResponse {
  [key: string]: InnerTrendsObject;
}
@Component({
    selector: 'app-engagement-lite',
    templateUrl: './engagement-lite.component.html',
    styleUrls: ['./engagement-lite.component.scss'],
    imports: [NgIf, NgClass, FormsModule, EngagementCardsComponent, EngagementRecordsSummaryDrilldownComponent, ScoreDropdownMenuComponent, LtmsWidgetToolsComponent, LtmsBarChartViewComponent, LtmsLoaderComponent, ScoreLineChartComponent, LtmsErrorComponent]
})
export class EngagementLiteComponent implements OnChanges {
  @Input() isEngagementPro: boolean = false;
  @Input() isDeviationEnabled = false;
  @Output() onCheckBoxChange: any = new EventEmitter<any>();
  @Output() onOptionChangeEvent: any = new EventEmitter<any>();
  @ViewChild(EngagementRecordsSummaryDrilldownComponent)
  engagementRecordsSummaryDrilldownComponent!: EngagementRecordsSummaryDrilldownComponent;
  
  // Component variables to track engagement service properties
  selectedRaterType: any;
  scaleRaterType: any;
  
  mainDiscription: string = 'Get a high-level overview of conversation activity, including records received and delivered, total responses, and the overall response rate. Track trends in request volume and response rate over time to monitor engagement performance.';
  lineGraphDetails: string = 'Response Rate (%) trend over time, viewable by various date granularities.';
  barGraphDetails: string = 'Summary of request volume across various stages over time, adjustable by date range.';
  accountName: string = '';
  brandName: string = '';
  hierarchyName: string = '';
  errorCode: string = '404';
  isDataAvailable: boolean = false;
  isFullScreen:boolean = false;
  fullScreenComponent = "";
  displayName: string = "";
  trendDisplayName: string = "";
  project_type: number = 0;
  isAccount: boolean = false;
  isExpanded: boolean = false;
  showRecordsJourney: boolean = localStorage.getItem('showRecordsJourney') !== null
  ? JSON.parse(localStorage.getItem('showRecordsJourney')!)
  : false
  showResponseDistribution: boolean = localStorage.getItem('showResponseDistribution') !== null
  ? JSON.parse(localStorage.getItem('showResponseDistribution')!)
  : false
  showChannelPerformance: boolean = localStorage.getItem('showChannelPerformance') !== null
  ? JSON.parse(localStorage.getItem('showChannelPerformance')!)
  : false
  overall_summary: TrendsApiResponse | [] = [];
  totalRecords: number = 0;
  filters: any = [];
  recordsJourneyData: any;
  distributionData: any;
  selectedBarTrendType: any = {};
  selectedLineTrendType: any = {};
  lineChartPlugins: any = {
    lineColor: '#E377C2',
    gradientStartColor: '#E377C2',
    gradientEndColor: '#E377C20F',
    borderWidth: 2,
    pointBorderWidth: 2,
    pointRadius: 6,
    pointBorderColor: '#ffffff',
    min: 0, // Minimum value for the y-axis
    // max: 100
  };
  lineChartdata: any = {
    labels: [],
    xText: "",  // Set the x-axis label dynamically based on trend_type
    yText: "",
    data: [],
    yTextDisplayName: "Response rate (%)"
  }
  isDataLoaded: boolean = false
  destroyRef = inject(DestroyRef);
  private dataSubscription?: Subscription;
  chartData: {
    responses: number[],
    delivered: number[],
    requests: number[],
    response_rates: number[]
    dates: string[]
  } = {
      "responses": [], //"Responses Received"
      "delivered": [], // "Requests Delivered"     add to store not responded data
      "requests": [], // "Requests Received"
      "response_rates": [], //"Response Rate %"
      "dates": []
    }
  dates = {
    startDate: '',
    endDate: ''
  };
  monthsShort = [
    "JAN", "FEB", "MAR", "APR", "MAY", "JUN",
    "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"
  ];
  dateFormats: any = {
    'Hourly': "HH:MM:SS",
    'Daily': "DD MMM 'YY",
    'Weekly': "DD MMM 'YY",
    'Monthly': "MMM 'YY",
    'Quarterly': "MMM 'YY",
    'Yearly': "YYYY",
  }
  widgetConfigBarGraph: any = {
    "elementId": "ltms-widget-bar-" + new Date().getMilliseconds(),
    "trendSelector": true,
    //TODO
    "download": {
      enable: true,
      componentId: '',
      data: {
        "accountOrProjectName": '',
        "headers": [],
        "body": [],
        rows: [],
        columns: [
          {
            order: 1,
            header: "Date",
            dataKey: "date",
          },
          {
            order: 2,
            header: "Records Received",
            dataKey: "requests",
          },
          {
            order: 3,
            header: "Records Delivered",
            dataKey: "delivered",
          },
          {
            order: 4,
            header: "Responses Received",
            dataKey: "responses",
          }
        ],
        title: "Engagement Request Trend Report",
        fileName: "Engagement Request Trend Report"
      }
    },
    "fullscreen": {
      enable: true,
      componentId: 'barChartId'
    }
  }

  barChartId = 'engagement_lite_bar' + new Date().getTime();
  lineChartId = 'engagement_lite_line' + new Date().getTime();

  barChartConfig: any = {
    chartId: "abc",
    chartType: 'bar',
    chart: {
      title: '',
      description: '',
      trendType: 'Monthly',
      xValues: [],
      hiddenValues: [],
      yValues: [],
      gradientColors: ["#301A4B", "#301A4B0F"],
      borderColor: '#301A4B',
      pointBorderColor: 'white',
      pointBackgroundColor: '#301A4B',
      pointHoverBackgroundColor: '#301A4B',
      maxBarThickness: 20
    },
    xAxis: {
      "title": {
        "text": "Request date"
      }
    },
    yAxis: {
      "title": {
        "text": "COUNT",
      },
      "min": 0, // Set the minimum value for the Y-axis
      "max": 100 // Set the maximum value for the Y-axis
    },
    download: {
      enable: true,
      componentId: '',
      data: {
        "accountOrProjectName": '',
        "headers": [],
        "body": []
      }
    },
    fullscreen: {
      enable: true,
      componentId: ''
    },
    enable_click: true,
    formatCompactYAxis: true
  }

  widgetConfigLineGraph: any = {
    "elementId": "ltms-widget-line-" + new Date().getMilliseconds(),
    "trendSelector": true,
    //TODO
    "download": {
      enable: true,
      componentId: '',
      data: {
        "accountOrProjectName": '',
        "headers": [],
        "body": [],
        rows: [],
        columns: [
          {
            order: 1,
            header: "Date",
            dataKey: "date",
          },
          {
            order: 2,
            header: "Response Rate(%)",
            dataKey: "responseRate"
          }
        ],
        title: "Engagement Response Rate Trend",
        fileName: "Engagement Response Rate Trend"
      }
    },
    "fullscreen": {
      enable: true,
      componentId: 'lineChartId'
    }
  }

  lineChartData: any = {
    chartId: "Lorem ipsum",
    chart: {
      title: '',
      description: '',
      trendType: 'Monthly',
      xValues: [],
      yValues: [],
      gradientColors: ["#E377C2", "#E377C20F"],
      borderColor: '#E377C2',
      pointBorderColor: 'white',
      pointBackgroundColor: '#E377C2',
      pointHoverBackgroundColor: '#E377C2',
    },
    xAxis: {
      "title": {
        "text": "Request week (start date)"
      }
    },
    yAxis: {
      "title": {
        "text": "RESPONSE RATE (%)",
      },
      "min_y": 0,
      "max_y": 5,
    }
  }
  isLineChartLoaded: boolean = false;
  restrictToday: boolean = false
  isBarChartLoaded: boolean = false
  isOnDrilldownChange: boolean = false;
  linedatalength: any;

  constructor(
    private helpersService: HelpersService,
    private engagementService: EngagementService,
    private cdRef: ChangeDetectorRef,
    private appStateService: AppStateService
  ) {
    // Initialize component variables to track engagement service properties
    this.selectedRaterType = this.engagementService.selectedRaterType;
    this.scaleRaterType = this.engagementService.scaleRaterType;
    
    effect(() => {
      if (this.appStateService.initialized()) {
        let datePickerObj: any = this.appStateService.datePicker();
        this.dates.startDate = datePickerObj.startDate;
        this.dates.endDate = datePickerObj.endDate;
        this.isAccount = this.appStateService.isAccount();
        this.recordsJourneyData = {
          current: {
            number_of_request_generated_rated: 0,
            number_of_unique_requests_delivered: 0,
            number_of_request_generated: 0
          }
        }
        this.filters = [];
        // this.filters = this.engagementService?.filters?.length ? this.engagementService?.filters : [];
        this.trendDisplayName = "";
        this.selectedBarTrendType = {};
        this.selectedLineTrendType = {};
        this.initializeCharts();
        this.isDataLoaded = false;
        this.isDataAvailable = true;
        this.isLineChartLoaded = false;
        this.isBarChartLoaded = false;
        let project_type_obj: any = this.appStateService.projectType()
        this.project_type = project_type_obj?.project_type;
        this.widgetConfigLineGraph.elementId = "ltms-widget-line-" + new Date().getMilliseconds();
        this.widgetConfigBarGraph.elementId = "ltms-widget-bar-" + new Date().getMilliseconds();
        this.isExpanded = this.engagementService.drilldownTable?.tableRow?.some(item => item.isExpanded)
          // trend details :- RR trend and Request trend
          // this.getOverallSummary(1, 'trend', this.dates, null, true, true);
          // Records Journey
        this.restrictToday = !this.engagementService.is_valid_date_range(this.dates.endDate, this.dates.startDate)
        this.cdRef.detectChanges();
        this.displayName = this.engagementService.getDisplayName();
        this.getOverallSummary(2, 'summary', this.dates, null, "overall");
        // Response distribution not required in lite
        // this.getOverallSummary(3, 'summary', this.dates, null, false, false);
        // this.getOverallSummary()
        let brandDetails: any = this.appStateService.brandDetails()
        this.brandName = brandDetails ? brandDetails.name : ''

        let hierarchyOptions: any[] = [];
        if (!this.isAccount && this.brandName) {
          var hierarchyStack = this.appStateService.hierarchyStack() ? this.appStateService.hierarchyStack() : [];
          var hierarchyList = _.cloneDeep(brandDetails?.hierarchy_list);
          var hierarchyAlias = _.cloneDeep(brandDetails?.hierarchy_list_alias);
          var key = _.find(Object.keys(hierarchyAlias), function (data) {
            return (data != 'default')
          });

          if (hierarchyList && hierarchyList[key] && hierarchyList[key].length > 1) {
            hierarchyOptions = [{
              "name": "Hierarchy",
              "view_type": "hr"
            }];
            if (hierarchyStack && hierarchyStack.length) {
              var alias = _.sortBy(hierarchyStack, ["field_id"])
              var alias_name = alias[alias.length - 1]
              this.hierarchyName = alias_name.group_key[0]
            }
          }
        } else {
          let accountDetails: any = this.appStateService.accountDetails()
          this.accountName = accountDetails.name;
          this.engagementService.prepareScalerRaterType()
        }
        
        // Update component variables when engagement service properties change
        this.selectedRaterType = this.engagementService.selectedRaterType;
        this.scaleRaterType = this.engagementService.scaleRaterType;
        // this.filters = this.engagementService?.selectedDrilldownFilter;
      }
    })
    // this.helpersService.datePicker.subscribe(data => {
    //   if (data) {
    //     this.dates.startDate = data.startDate;
    //     this.dates.endDate = data.endDate;
    //   }
    // })

    // Add event listeners for Escape key and click outside
    document.addEventListener('keydown', this.handleKeyDown.bind(this));
    document.addEventListener('click', this.handleClickOutside.bind(this));
  }
  // Getter methods to access engagement service properties
  get selectedRaterTypeValue() {
    return this.engagementService.selectedRaterType;
  }
  get scaleRaterTypeValue() {
    return this.engagementService.scaleRaterType;
  }
  // Method to handle Escape key press
  handleKeyDown(event: KeyboardEvent) {
    if (event.key === 'Escape' && this.isFullScreen) {  
      this.engagementService.setFullscreenEngagement(false);
      if(this.engagementService?.engagemetState['bar-view']){
        this.onFullScreen(null, 'bar-view'); // Exit fullscreen
      } else if(this.engagementService?.engagemetState['chart-view']){
          this.onFullScreen(null, 'chart-view'); // Exit fullscreen
      }
    }
  }

  // Method to handle clicks outside the overlay
  handleClickOutside(event: MouseEvent) {
    const overlayElements = document.getElementsByClassName('overlay'); // Get all elements with the overlay class
    const fullscreenCardElements = document.getElementsByClassName('content'); // Get all elements with the content class

    // Check if the clicked element is the overlay
    const isOverlayClick = Array.from(overlayElements).some(overlay => overlay.contains(event.target as Node));
    const isFullscreenCardClick = Array.from(fullscreenCardElements).some(card => card.contains(event.target as Node));

    if (this.isFullScreen && !isFullscreenCardClick && isOverlayClick) { // Only exit fullscreen if the overlay is clicked
      this.engagementService.setFullscreenEngagement(false);
      if(this.engagementService?.engagemetState['bar-view']){
        this.onFullScreen(null, 'bar-view'); // Exit fullscreen
      } else if(this.engagementService?.engagemetState['chart-view']){
          this.onFullScreen(null, 'chart-view'); // Exit fullscreen
      }
    }
  }

  onCheckboxClick(option: string) {

    if (option === 'recordsJourney') {
      this.showRecordsJourney = !this.showRecordsJourney;
      localStorage.setItem('showRecordsJourney', JSON.stringify(this.showRecordsJourney));
    }
    if (option === 'responseDistribution') {
      this.showResponseDistribution = !this.showResponseDistribution;
      localStorage.setItem('showResponseDistribution', JSON.stringify(this.showResponseDistribution));
    }
    if (option === 'channelPerformance') {
      this.showChannelPerformance = !this.showChannelPerformance;
      localStorage.setItem('showChannelPerformance', JSON.stringify(this.showChannelPerformance));
    }
  }

  setDateRange(event){
    const dateRange = {
      "formatedStartDate":  moment(event?.dateRange?.startDate, "YYYYMMDD").format("DD MMM 'YY"),
      "formatedEndDate":  moment(event?.dateRange?.endDate, "YYYYMMDD").format("DD MMM 'YY"),
      "startDate": event?.dateRange?.startDate,
      "endDate": event?.dateRange?.endDate,
      "isCustomDateRangeSelected": true,
      "isPresetActive": false,
      "isRequestDate": Helpers?.datePicker?.isRequestDate,
      "selectedTrend": Helpers?.datePicker?.selectedTrend,
      "trendType": '',
      "dateFilterType": Helpers?.datePicker?.dateFilterType,
      "is_brand_creation_date_range": Helpers?.datePicker?.is_brand_creation_date_range
    }
    if(event?.dateRange?.startDate != this.dates?.startDate || event?.dateRange?.endDate != this.dates?.endDate){
      this.helpersService.setDatePicker(dateRange)
    }
  }
  

  ngOnInit() {
    this.showRecordsJourney = JSON.parse(localStorage.getItem('showRecordsJourney') || 'false');
    this.showResponseDistribution = JSON.parse(localStorage.getItem('showResponseDistribution') || 'false');
    this.showChannelPerformance = JSON.parse(localStorage.getItem('showChannelPerformance') || 'false');

    // this.initializecomponent()
    if (this.isEngagementPro && this.engagementService.getFullScreen('bar-view')) {
      this.onFullScreen("", "bar-view")
    }
  }

  onDrilldownChange(filters?: any) {
    this.isOnDrilldownChange = true;
    this.isBarChartLoaded = false;
    this.isLineChartLoaded = false;
    this.initializeCharts();
    if(filters && !_.isEmpty(filters)){
      this.filters = this.engagementService.setDrilldownFilters(filters);
    }
    this.trendDisplayName = this.engagementService.trendDisplayName;
    this.widgetConfigBarGraph['download']['data']['title'] = this.trendDisplayName ? "Engagement Request Trend" + " - " + this.selectedBarTrendType.name + " - " + this.trendDisplayName : "Engagement Request Trend" + " - " + this.selectedBarTrendType.name
    this.widgetConfigLineGraph['download']['data']['title'] = this.trendDisplayName ? "Engagement Request Trend" + " - " + this.selectedLineTrendType.name + " - " + this.trendDisplayName : "Engagement Request Trend" + " - " + this.selectedLineTrendType.name

    if (filters?.projectId){
      this.filters.brand_id = filters?.projectId
    }
    if (filters?.brand_id_list?.length > 0){
      this.filters.brand_id_list = filters?.brand_id_list
    }
    this.getOverallSummary(1, 'trend', this.dates, this.selectedBarTrendType, "barChart");
    this.getOverallSummary(1, 'trend', this.dates, this.selectedLineTrendType, "lineChart");
    this.isBarChartLoaded = false;
    this.isLineChartLoaded = false;
  }

  initializeCharts() {
    this.lineChartdata.data = [];
    this.lineChartdata.labels = [];
    this.barChartConfig.chart.xValues = [];
    this.barChartConfig.chart.yValues = [0];
  }
  // not in use, added inside effect in constructor
  initializecomponent() {
    this.helpersService.appState.subscribe(
      (response: any) => {
        if (response && !response.pending) {
          this.recordsJourneyData = {
            current: {
              number_of_request_generated_rated:0,
              number_of_unique_requests_delivered:0,
              number_of_request_generated:0
            }
          } 
          this.filters = [];
          this.trendDisplayName = "";
          this.initializeCharts();
          this.isDataLoaded = false;
          this.isDataAvailable = true;
          this.isLineChartLoaded = false;
          this.isBarChartLoaded = false;
          this.project_type = response?.projectType?.project_type;
          this.widgetConfigLineGraph.elementId = "ltms-widget-line-" + new Date().getMilliseconds();
          this.widgetConfigBarGraph.elementId = "ltms-widget-bar-" + new Date().getMilliseconds(),
            // trend details :- RR trend and Request trend
            // this.getOverallSummary(1, 'trend', this.dates, null, true, true);
            // Records Journey
          this.restrictToday = !this.engagementService.is_valid_date_range(this.dates.endDate,this.dates.startDate)
          this.cdRef.detectChanges();
          this.displayName = this.engagementService.getDisplayName();
          this.getOverallSummary(2, 'summary', this.dates, null, "overall");
          // Response distribution not required in lite
          // this.getOverallSummary(3, 'summary', this.dates, null, false, false);
          // this.getOverallSummary()
          this.brandName = response.brandDetails ? response.brandDetails.name : ''

          let hierarchyOptions: any[] = [];
          if (this.brandName) {
            var hierarchyStack = response.hierarchyStack ? Helpers.hierarchyStack : [];
            var hierarchyList = _.cloneDeep(Helpers.brandDetails.hierarchy_list);
            var hierarchyAlias = _.cloneDeep(Helpers.brandDetails.hierarchy_list_alias);
            var key = _.find(Object.keys(hierarchyAlias), function (data) {
              return (data != 'default')
            });

            if (hierarchyList && hierarchyList[key] && hierarchyList[key].length > 1) {
              hierarchyOptions = [{
                "name": "Hierarchy",
                "view_type": "hr"
              }];
              if (hierarchyStack && hierarchyStack.length) {
                var alias = _.sortBy(hierarchyStack, ["field_id"])
                var alias_name = alias[alias.length - 1]
                this.hierarchyName = alias_name.group_key[0]
              }
            }
          } else {
            this.accountName = response.accountDetails.name;
          }
        }
      }

    )
  }

  onTrendTypeChange(trendType: any) {
    if (!this.selectedBarTrendType.value || (this.selectedBarTrendType.value != trendType.value)) {
      this.isBarChartLoaded = false
      this.selectedBarTrendType = trendType;
      this.getOverallSummary(1, 'trend', this.dates, trendType, "barChart");
      if (trendType.value && trendType.value != "") {
        this.widgetConfigBarGraph['download']['data']['fileName'] = "Engagement Request Trend" + " " + trendType.name
        this.widgetConfigBarGraph['download']['data']['title'] = this.trendDisplayName? "Engagement Request Trend" + " - " + trendType.name + " - " + this.trendDisplayName : "Engagement Request Trend" + " - " + trendType.name
      }
      // this.isBarChartLoaded = true
    }

  }

  onLineTrendTypeChange(trendType: any) {
    if (!this.selectedLineTrendType.value || (this.selectedLineTrendType.value != trendType.value)) {
      this.isLineChartLoaded = false
      this.selectedLineTrendType = trendType;
      this.getOverallSummary(1, 'trend', this.dates, trendType, "lineChart");
      if (trendType.value && trendType.value != "") {
        this.widgetConfigLineGraph['download']['data']['fileName'] = "Engagement Response Rate Trend" + " " + trendType.name
        this.widgetConfigLineGraph['download']['data']['title'] = this.trendDisplayName? "Engagement Request Trend" + " - " + trendType.name + " - " + this.trendDisplayName : "Engagement Request Trend" + " - " + trendType.name
      }
      // this.isLineChartLoaded = true
    }
  }

  onOptionChange($event){
    this.engagementService.clearDrilldownHistory();
    this.filters = [];
    this.isBarChartLoaded = false;
    this.isLineChartLoaded = false;
    this.displayName = this.engagementService.getDisplayName();
    this.trendDisplayName = this.engagementService.getDisplayName();
    if (this.engagementRecordsSummaryDrilldownComponent) {
      this.engagementRecordsSummaryDrilldownComponent.isDataLoaded = false;
    }
    if($event?.field_id){
      this.engagementService.setSelectedRaterType($event);
      // Update component variables to ensure UI updates
      this.selectedRaterType = this.engagementService.selectedRaterType;
      this.scaleRaterType = this.engagementService.scaleRaterType;
      this.cdRef.detectChanges();
      this.getOverallSummary(2, 'summary', this.dates, null, "overall");
      this.getOverallSummary(1, 'trend', this.dates, this.selectedBarTrendType, "barChart");
      this.getOverallSummary(1, 'trend', this.dates, this.selectedLineTrendType, "lineChart");
    }
    this.onOptionChangeEvent.emit($event)
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['isDeviationEnabled'] && !changes['isDeviationEnabled'].firstChange && this.dates?.startDate) {
      this.getOverallSummary(2, 'summary', this.dates, null, 'overall');
    }
  }

  // overall summary based on the provided query type, view type, dates, trend data, and chart_type('barChart'/'lineChart')
  getOverallSummary(
    query_type: any,
    view_type: any,
    dates: { startDate: string; endDate: string; },
    trend_data: any,
    chart_type: string
  ) {
    // Utility function to convert dates to "YYYYMMDD" format
    const formatDate = (date: Date): string => {
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, "0");
      const day = date.getDate().toString().padStart(2, "0");
      return `${year}${month}${day}`;
    };

    // const startDate = (dates.startDate);
    // const endDate = (dates.endDate);
    // const today = new Date();
    // const yesterday = new Date();
    // yesterday.setDate(today.getDate() - 1)

    // if (
    //   (startDate) === formatDate(today) ||
    //   (startDate) === formatDate(yesterday)
    // ) {
    //   this.restrictToday = true
    //   this.isDataLoaded = true;

    //   localStorage.setItem('restrictToday', JSON.stringify(this.restrictToday));
    //   return;
    // }
    // this.restrictToday = false
    var params = this.engagementService.getSummaryParams({
      "rater_type": -1,
      "query_type": query_type,
      "view_type": view_type,
      "filters": this.filters,
      "dates": dates,
      "trend_type": (trend_data && trend_data.value) ? trend_data.value : 2,
      "is_deviation_enabled": query_type === 2 ? this.isDeviationEnabled : undefined,
    })
    // this.isDataLoaded = false;
    // this.isDataAvailable = false;
    // this.isBarChartLoaded = false;
    if (dates.startDate == dates.endDate) {
      params.trend_type = 0;
    }
    if (this.filters?.brand_id){
      params.brand_id = this.filters.brand_id;
    }
    if (this.filters?.brand_id_list){
      params.brand_id_list = this.filters?.brand_id_list;
    }
    if (this.project_type) {
      params.project_type = this.project_type;
    }
    this.dataSubscription = this.engagementService.getEngagementSummary(params).pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
      next: (response) => {
        if (response &&
          response.code == 0 &&
          response.data.overall_summary_details &&
          (response.data.overall_summary_details &&
            Object.keys(response.data.overall_summary_details).length > 0)) {
          this.isDataAvailable = true;
          if (params["view_type"] === 'trend') {
            this.overall_summary = response.data.overall_summary_details.trends
            var trend_name = (trend_data && trend_data.name) ? trend_data.name : ''
            this.prepareDataForTrendJourney(trend_name, chart_type);
            this.isDataAvailable = true;
            // this.isBarChartLoaded = true;
            // this.isLineChartLoaded = true;
            // this.isDataLoaded = true;
          }
          if (params["view_type"] === 'summary' && params["query_type"] === 2) {
            this.recordsJourneyData = response.data.overall_summary_details.summary;
            // this.prepareDataForRequestJourney(this.recordsJourneyData)
            this.isDataAvailable = true;
            // this.isDataLoaded = true;
          }
          if (params["view_type"] === 'summary' && params["query_type"] === 3) {
            this.distributionData = response.data.overall_summary_details.summary;
            this.isDataAvailable = true;
            // this.isDataLoaded = true;
          }
          this.isDataLoaded = true;
        } else {
          this.isDataAvailable = false;
          this.isDataLoaded = true;
          this.errorCode = '404';
          this.isBarChartLoaded = true;
          this.isLineChartLoaded = true;
        }
      },
      error: (err) => {
        this.isDataAvailable = false
        this.isDataLoaded = true;
        this.isBarChartLoaded = true;
        this.isLineChartLoaded = true;
        if (err.status == '500') {
          this.errorCode = '500'
        } else if (err.status == "408") {
          this.errorCode = '408'
        }
      }
    })
  }


  onFullScreen(event: any, cardName: string) {
    this.isFullScreen = !this.isFullScreen;
    this.engagementService.setFullScreen(cardName, this.isFullScreen);
    this.fullScreenComponent = this.isFullScreen ? cardName : '';
  }
  // Function to format the given date string based on the selected trend type
  // e.g.,"12:30 PM" (Hourly), "Jan '25" (Monthly), "Jan-Mar '25" (Quarterly), "2025" (Yearly).
  fromateDateString(dateString: string, selectedTrendType): string {
    if (selectedTrendType == 'Hourly') {
      return moment.utc(dateString).format("hh:mm A")
    } else if (selectedTrendType == 'Monthly') {
      return moment.utc(dateString).format("MMM 'YY")
    } else if (selectedTrendType == 'Quarterly') {
      return moment.utc(dateString).format('MMM') + "-" + moment.utc(dateString).endOf('quarter').format('MMM') + " " + moment.utc(dateString).format("'YY")
    } else if (selectedTrendType == 'Yearly') {
      return moment.utc(dateString).format("YYYY")
    } else if (selectedTrendType == "utc") {
      return moment.utc(dateString).format("YYYY-MM-DD HH:mm:ss")
    }
    return moment.utc(dateString).format("DD MMM 'YY");
  }

  getTotalCount(data) {
    const totals = {
      number_of_request_generated_rated: 0,
      number_of_unique_requests_delivered: 0,
      number_of_request_generated: 0,
      number_of_requests_received: 0,
      responseRate: 0
    };

    for (const date in data) {
      const record = data[date];
      totals.number_of_request_generated_rated += record.number_of_request_generated_rated;
      totals.number_of_unique_requests_delivered += record.number_of_unique_requests_delivered;
      totals.number_of_request_generated += record.number_of_request_generated;
      totals.number_of_requests_received += record.number_of_requests_received;
    }
    return totals;
  }
  // Function to prepare data for trend journey based on the given trend type and chart type
  prepareDataForTrendJourney(trend_type: string, chart_type: string) {
    const isBarChart = chart_type == 'barChart' ? true : false;
    const isLineChart = chart_type == 'lineChart' ? true : false; 
    // Get the total count from overall summary (used for total calculations)
    let total = this.getTotalCount(this.overall_summary)
    this.chartData = {
      "responses": [], //"Responses Received"
      "delivered": [], // "Requests Delivered"     add to store not responded data
      "requests": [], // "Requests Received"
      "response_rates": [], //"Response Rate %"
      "dates": []
    }
    // Clear the rows of download data for Bar and Line chart based on chart type
    this.widgetConfigBarGraph['download']['data']['rows'] = isBarChart ? [] : this.widgetConfigBarGraph['download']['data']['rows']
    this.widgetConfigLineGraph['download']['data']['rows'] = isLineChart ? [] : this.widgetConfigLineGraph['download']['data']['rows']
    let maxResponseRate = 1;

    if (Object.keys(this.overall_summary).length) {
      for (let date in this.overall_summary) {
        let summary = this.overall_summary[date];

        summary.number_of_requests_received = this.engagementService.getRequestRecieved(summary)

        if (date && (summary.number_of_requests_received || summary.number_of_request_generated_rated)) {
          summary.number_of_unique_delivered = summary.number_of_unique_requests_delivered;
          let detailedSummary: {
            responded: number,
            delivered: number,
            number_of_requests: number
            not_responded: number,
            responseRate: number,
            time: string
          } = {
            responded: 0,
            delivered: 0,
            number_of_requests: 0,
            not_responded: 0,
            responseRate: 0,
            time: ""
          };
          // Format the time based on chart type (Bar or Line)
          if (isBarChart) {
            detailedSummary.time = this.fromateDateString(summary.key_as_string, "utc");
          } else if (isLineChart) {
            detailedSummary.time = this.fromateDateString(summary.key_as_string, this.selectedLineTrendType['name']);
          }
          detailedSummary.responded = (summary.number_of_request_generated_rated || 0);
          detailedSummary.delivered = (summary.number_of_unique_requests_delivered || 0);
          detailedSummary.number_of_requests = (summary.number_of_requests_received || 0);

          if ((detailedSummary.number_of_requests == detailedSummary.responded) && detailedSummary.responded >= 0) {
            detailedSummary.responseRate = 100;
          } else {
            detailedSummary.responseRate = (this.engagementService.getResponsePercentage(summary)).toFixed(1);
          }
          if (parseFloat(detailedSummary.responseRate.toString()) > maxResponseRate) {
            maxResponseRate = parseFloat(detailedSummary.responseRate.toString());
          }

          // pushing data based on chart type
          this.chartData.responses.push(detailedSummary.responded);
          this.chartData.response_rates.push(detailedSummary.responseRate);
          this.chartData.delivered.push(detailedSummary.delivered);
          this.chartData.requests.push(detailedSummary.number_of_requests);
          this.chartData.dates.push(detailedSummary.time);
          if (isBarChart) {
            this.widgetConfigBarGraph['download']['data']['rows'].push({
              date: this.fromateDateString(detailedSummary.time, this.selectedBarTrendType['name']),
              requests: detailedSummary.number_of_requests,
              delivered: detailedSummary.delivered,
              responses: detailedSummary.responded
            })
          }
          if (isLineChart) {
            this.widgetConfigLineGraph['download']['data']['rows'].push({
              date: detailedSummary.time,
              responseRate: detailedSummary.responseRate
            })
          }

        }
      }

      if (isBarChart) {
        this.barChartConfig.chart.trendType = trend_type;
        this.barChartConfig.chart.yValues = [
          {
            label: "Records Received",
            borderColor: "#9467BD", // Updated color
            backgroundColor: "#9467BD", // Updated color
            data: this.chartData.requests,
            // maxBarThickness: 40,
          },
          {
            label: "Records Delivered",
            borderColor: "#FF7F0E", // Updated color
            backgroundColor: "#FF7F0E", // Updated color
            data: this.chartData.delivered,
            // maxBarThickness: 40,
          },
          {
            label: "Responses Received",
            borderColor: "#2CA02C", // Updated color
            backgroundColor: "#2CA02C", // Updated color
            data: this.chartData.responses,
            // maxBarThickness: 40,
          },
        ];

        this.barChartConfig.chart.xValues = this.chartData.dates;
        this.barChartConfig.xAxis.title.text = this.getAxisLebels(trend_type, "Request ");
        this.barChartId = 'engagement_lite_bar' + new Date().getTime();
        this.widgetConfigBarGraph['download']['data']['rows'].push({
          date: "Total",
          delivered: total.number_of_unique_requests_delivered
            ? total.number_of_unique_requests_delivered
            : 0,
          requests: total.number_of_request_generated + total.number_of_request_generated_rated,
          responses: total.number_of_request_generated_rated,
        });
        this.isBarChartLoaded = true;
      }

      if (isLineChart) {
        let xAxisText = this.getAxisLebels(trend_type, "Request ")
        let obj: any = {
          labels: this.chartData.dates,
          xText: xAxisText,  // Set the x-axis label dynamically based on trend_type
          yText: "RESPONSE RATE (%)",
          data: this.chartData.response_rates,
          yTextDisplayName: "Response rate (%)"
        };

        this.linedatalength = obj.data.length;
        this.lineChartdata = obj;

        this.widgetConfigLineGraph['download']['data']['rows'].push({
          date: "Total",
          responseRate: (this.engagementService.getResponsePercentage(this.recordsJourneyData.current)).toFixed(1)
        })
        this.isLineChartLoaded = true;
      }

      this.chartData = { ...this.chartData };
      this.isDataAvailable = true;
    } else {

      this.chartData = {
        "responses": [], //"Responses Received"
        "delivered": [], // "Requests Delivered"     add to store not responded data
        "requests": [], // "Requests Received"
        "response_rates": [], //"Response Rate %"
        "dates": []
      };

      if (isLineChart) {
        this.lineChartData.chart.trendType = trend_type
        this.lineChartData.chart.xValues = this.chartData.dates
        this.lineChartData.chart.yValues = this.chartData.response_rates
        this.lineChartId = 'engagement_lite_line' + new Date().getTime();
        this.isLineChartLoaded = true;
      }

      if (isBarChart) {
        this.barChartConfig.chart.trendType = trend_type
        this.barChartConfig.chart.yValues = [{
          label: "Requests received",
          data: this.chartData.requests,
        }, {
          label: "Requests delivered",
          data: this.chartData.delivered,
        },
        {
          label: "Responses Received",
          data: this.chartData.responses,
        }
        ]

        this.barChartConfig.chart.xValues = this.chartData.dates
        this.barChartId = 'engagement_lite_bar' + new Date().getTime();
        this.isBarChartLoaded = true;
      }
    }
  }

  getAxisLebels(trend_type: string, xAxisText: string) {
    if (trend_type === "Hourly") {
      xAxisText += "Time "
    }
    else if (trend_type === "Weekly") {
      xAxisText += "Week (Start Date)";  // Append 'week' if trend_type is Weekly
    }
    else if (trend_type === "Monthly") {
      xAxisText += "Month ";  // Append 'month' if trend_type is Monthly
    }
    else if (trend_type === "Quarterly") {
      xAxisText += "Quarter ";  // Append 'Quarter' if trend_type is Quarterly
    }
    else if (trend_type === "Daily") {
      xAxisText += "Date ";  // Append 'Date' if trend_type is Daily 
    }
    else if (trend_type === "Yearly") {
      xAxisText += "Year";  // Append 'year' if trend_type is Year 
    }
    return xAxisText;
  }
  
  ngOnDestroy(): void {
    // Unsubscribe to prevent memory leaks
    if (this.dataSubscription) {
      this.dataSubscription.unsubscribe();
    }
    // Remove event listeners
    document.removeEventListener('keydown', this.handleKeyDown.bind(this));
    document.removeEventListener('click', this.handleClickOutside.bind(this));
  }

}
/*
NOTES:

isEngagementPro: Determines if the engagement is Pro version.
onCheckBoxChange: Event emitter to toggle response distribution and records journey in engagement pro tab.
isDataAvailable, isDataLoaded, isBarChartLoaded, isLineChartLoaded, showRecordsJourney(pro), and showResponseDistribution(pro): control the display and data availability.
restrictToday: Controls if date is today or yesterday, data is restricted based on local storage.
lineChartdata and barChartConfig: Define the visual appearance, axis data, and settings for the line and bar charts, such as colors, point styles, and y-axis scaling.
widgetConfigBarGraph and widgetConfigLineGraph: Configure widget options for fullscreen, download, and trend selection for both charts.
chartData: Stores data for chart plotting, including responses, requests, and response rates.
dateFormats: Defines different date format options for various time intervals like hourly, daily, monthly, etc.

PendingIssues:

test restrict today yesterday and remove commented codes
*/